import { Eye, EyeOff } from 'lucide-react';
import { forwardRef, useState, type InputHTMLAttributes } from 'react';

import { cn } from '@/nucleo/utilitarios';
import { Input } from '@/ui/base/input';

/**
 * Campo de senha com o botão de mostrar/ocultar.
 *
 * Existe só nas três telas do inscrito — portão, entrar e recuperar — por
 * decisão do dono (D-10). Mostrar a senha ajuda quem digita em celular, e o
 * botão diz em voz alta o que faz, para leitor de tela.
 */
export const CampoDeSenha = forwardRef<
  HTMLInputElement,
  Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>
>(function CampoDeSenha({ className, ...props }, ref) {
  const [visivel, setVisivel] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visivel ? 'text' : 'password'}
        className={cn('pr-11', className)}
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        {...props}
      />
      <button
        type="button"
        onClick={() => setVisivel((atual) => !atual)}
        aria-label={visivel ? 'Ocultar a senha' : 'Mostrar a senha'}
        aria-pressed={visivel}
        className="absolute right-1 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-md text-muted-foreground hover:text-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring"
      >
        {visivel ? (
          <EyeOff aria-hidden="true" className="h-4 w-4" />
        ) : (
          <Eye aria-hidden="true" className="h-4 w-4" />
        )}
      </button>
    </div>
  );
});
